import * as Yup from 'yup';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { NUMBERS } from '../resources/number-constants';

const missedMessage = 'You missed this.';
const passwordMatch = 'Passwords must match.';

export const signupValidationSchema = Yup.object({
  fullName: Yup.string()
    .required(missedMessage),
  companyName: Yup.string()
    .required(missedMessage),
  email: Yup.string()
    .email('Invalid email address.')
    .matches(
      /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      'Email must be a valid format, e.g., user@example.com'
    )
    .required(missedMessage),
  phoneNumber: Yup.string()
    .test('is-valid-phone', 'Invalid phone number.', (value) => {
      if (!value) return false;
      const phoneNumber = parsePhoneNumberFromString(value);
      return phoneNumber ? phoneNumber.isValid() : false;
    })
    .min(NUMBERS.TEN, 'Phone number must be at least 10 digits.')
    .max(NUMBERS.FIFTEEN, 'Phone number must be 15 digits or less.')
    .required(missedMessage),
  acceptedTerms: Yup.boolean()
    .oneOf([true], 'You must accept the terms and conditions.'),
  password: Yup.string()
    .required(missedMessage)
    .matches(
      /^(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/,
      'Password must be at least 8 characters long, contain an uppercase letter, a number, and a special character.'
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), ''], passwordMatch)
    .required(missedMessage),
});

export const signInValidationSchema = Yup.object({
  email: Yup.string()
    .required(missedMessage),
  password: Yup.string()
    .required(missedMessage)
});

export const changePasswordValidationSchema = Yup.object({
  currentPassword: Yup.string()
    .required(missedMessage),
  newPassword: Yup.string()
    .required(missedMessage)
    .matches(
      /^(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/,
      'Password must be at least 8 characters long, contain an uppercase letter, a number, and a special character.'
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('newPassword'), ''], passwordMatch)
    .required(missedMessage),
});

export const forgetPasswordValidationSchema = Yup.object({
  email: Yup.string()
    .required(missedMessage),
});

export const resetPasswordValidationSchema = Yup.object({
  password: Yup.string()
    .required(missedMessage)
    .matches(
      /^(?=.*[A-Z])(?=.*[a-zA-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).{8,}$/,
      'Password must be at least 8 characters long, contain an uppercase letter, a number, and a special character.'
    ),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password'), ''], passwordMatch)
    .required(missedMessage),
});

export const companyProfileValidationSchema = (companyName: any) =>
  Yup.object().shape({
    companyName: companyName
      ? Yup.string().nullable() // Not required if prop is provided
      : Yup.string().required(missedMessage), // Required if not provided
    address: Yup.string().required(missedMessage),
    annualRevenue: Yup.object().required(missedMessage),
    industry: Yup.object().required(missedMessage),
    webAddress: Yup.string()
      .matches(/^(https?:\/\/|www\.)\S+$/, 'Invalid URL format.')
      .required(missedMessage),
    companySize: Yup.object().required(missedMessage),
  });
